import AboutUS from "./components/AboutUS";
import Home from "./components/Home";
import Menu from "./components/Menu";
import Navbar from "./components/Navbar";
import Products from "./components/Products";

function App() {
  return (
    <>
      <Navbar />
      <Home />
      <Products />
      <Menu />
      <AboutUS />
    </>
  );
}

export default App;
